module.exports = __webpack_public_path__ + "assets/img/dzh-4.f5be8492.jpg";